import guestMiddleware from "../router/middlewares/guestMiddleware";
import authMiddleware from "../router/middlewares/authMiddleware";
import permissionMiddleware from "./middlewares/permissionMiddleware";
import notVerifiedMiddleware from "./middlewares/notVerifiedMiddleware";
import {RouteRecordRaw} from "vue-router";

const routes = [
    /*
     | Auth routes.
     */
    {
        path: "/",
        redirect: { name: "portal.homepage" },
        component: () => import("../layouts/AuthLayout.vue"),
        children: [
            {
                path: "login",
                name: "auth.login",
                component: () => import("../pages/auth/Login.vue"),
                beforeEnter: [guestMiddleware],
            },
            {
                path: "register",
                name: "auth.register",
                component: () => import("../pages/auth/Register.vue"),
                beforeEnter: [guestMiddleware],
            },
            {
                path: "forgot-password",
                name: "auth.forgot-password",
                component: () => import("../pages/auth/ForgotPassword.vue"),
                beforeEnter: [guestMiddleware],
            },
            {
                path: "reset-password",
                name: "auth.reset-password",
                component: () => import("../pages/auth/ResetPassword.vue"),
                beforeEnter: [guestMiddleware],
            },
            {
                path: "email-verification",
                name: "auth.email-verification",
                component: () => import("../pages/auth/EmailVerification.vue"),
                beforeEnter: [notVerifiedMiddleware],
            },
        ],
    },

    /*
     | Portal routes.
     */
    {
        path: "/portal",
        name: "portal.homepage",
        redirect: { name: "portal.documents" },
        component: () => import("../layouts/PortalLayout.vue"),
        beforeEnter: [authMiddleware],
        children: [
            {
                path: "documents",
                name: "portal.documents",
                meta: { clsnam: "documents" },
                component: () => import("../pages/portal/Documents.vue"),
                beforeEnter: [permissionMiddleware],
            },
            {
                path: "ure",
                name: "portal.ure",
                meta: { clsnam: "ure" },
                component: () => import("../pages/portal/URE.vue"),
                beforeEnter: [permissionMiddleware],
            },
            {
                path: "users",
                name: "portal.users",
                meta: { clsnam: "users" },
                component: () => import("../pages/portal/Users.vue"),
                beforeEnter: [permissionMiddleware],
            },
            {
                path: "periods",
                name: "portal.periods",
                meta: { clsnam: "periods" },
                component: () => import("../pages/portal/Periods.vue"),
                beforeEnter: [permissionMiddleware],
            },
        ],
    },

    /*
     | The default route, when none of the above matches.
     */
    {
        path: "/:pathMatch(.*)*",
        name: "PageNotFound",
        component: () => import("../pages/PageNotFound.vue"),
    },
] as RouteRecordRaw[];

export default routes;
